import { useSelector } from 'react-redux';

const WhiteLabelShow = ({ children, objectKey }) => {
  const { whitelabel } = useSelector((state) => state.auth);

  return whitelabel?.behaviors[objectKey] ? children : null;
};

export default WhiteLabelShow;
